import BaseChartCard from 'common/components/BaseChartCard'
import useMedia from 'common/hooks/useMedia'
import { useGetFoodLineChart } from 'modules/food/api/queries'
import { useTranslation } from 'react-i18next'

import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

import FoodLineChart from '../FoodLineChart'

const FoodChart = () => {
  const { t } = useTranslation('food')
  const isMobile = useMedia('sm')
  const theme = useTheme()
  const { refetch } = useGetFoodLineChart()

  return (
    <BaseChartCard title={t('consuming.food.chart.title.short')} refresh={refetch}>
      {isMobile && (
        <Typography
          variant="caption"
          sx={{ fontWeight: theme.typography.fontWeightBold, color: theme.palette.text.secondary }}
        >
          {t('food:food.amount.kg')}
        </Typography>
      )}
      <FoodLineChart />
    </BaseChartCard>
  )
}

export default FoodChart
